import { Icon } from "@iconify/react/dist/iconify.js";

const PromotionsStickyButton = () => {
    const scrollToPromotions = () => {
        const target = document.getElementById("promocje");

        if (target) {
            target.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }

        history.pushState(null, "", "#promocje");
    };

    return (
        <button
            type="button"
            onClick={scrollToPromotions}
            className="absolute top-[80px] maxMd:top-4 right-0 z-20 flex items-center justify-center gap-2 maxMd:gap-1.5 bg-i-red p-5 maxMd:px-3 maxMd:py-2.5 rounded-tl-[12px] rounded-bl-[12px] shadow-[0px_4px_6.15px_rgba(0,0,0,0.57)] transition-opacity duration-200 hover:opacity-90"
            title="Sprawdź promocje"
        >
            <Icon
                icon="lsicon:badge-promotion-outline"
                width={40}
                height={40}
                className="text-white shrink-0 maxMd:!w-6 maxMd:!h-6"
            />
            <span className="text-white text-p leading-label maxMd:text-4 maxMd:leading-4 font-bold uppercase tracking-[0.45px] whitespace-nowrap">
                Sprawdź promocje
            </span>
        </button>
    );
};

export default PromotionsStickyButton;
